import { render, staticRenderFns } from "./FreightManagement.vue?vue&type=template&id=253de78f&scoped=true"
import script from "./FreightManagement.vue?vue&type=script&lang=js"
export * from "./FreightManagement.vue?vue&type=script&lang=js"
import style0 from "./FreightManagement.vue?vue&type=style&index=0&id=253de78f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253de78f",
  null
  
)

export default component.exports